import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { TokenService } from '../services/token.service';
import { UsuarioService } from '../services/usuario.service';
import { BeneficiaryType } from '../enum/beneficiary-type';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalPdvDesligadoComponent } from '../modals/modal-pdv-desligado/modal-pdv-desligado.component';
@Injectable()
export class pdvGuard {
    pdvAcess: any = null;

    get beneficiaryType() { return BeneficiaryType; }

    constructor(private router: Router, private userService: UsuarioService, private tokenService: TokenService, private modalService: NgbModal) {
        if (this.pdvAcess == null) {
            this.pdvAcess = this.tokenService.getActiveUser();
        }
        this.canActivate
    }
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {       

        if (this.pdvAcess.hasPdvPermission != null && this.pdvAcess.hasPdvPermission?.status == 'DESLIGADO' && this.pdvAcess.socialSecurityProfile?.statusId != this.beneficiaryType.ASSISTIDO) {
            return true;
        } else if(this.pdvAcess.hasPdvPermission != null && this.pdvAcess.hasPdvPermission?.status == 'ATIVO' && this.pdvAcess.socialSecurityProfile?.statusId != this.beneficiaryType.ASSISTIDO){
            this.modalService.open(ModalPdvDesligadoComponent, { windowClass: 'custom-modal-size', size: 'lg', centered: true });            
            return false;
        }else{

            this.router.navigate(['/']);
            return false;
        }
    }
}